import React from 'react';

import BaseText from '../base-text';

import { TextVariantProps } from './type';

const LG = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={18} fontWeight={400} lineHeight={1.3}>
    {children}
  </BaseText>
);

const MD = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={15} fontWeight={400} lineHeight={1.3}>
    {children}
  </BaseText>
);

const MDMedium = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={15} fontWeight={500} lineHeight={1.3}>
    {children}
  </BaseText>
);

const MDBold = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={15} fontWeight={700} lineHeight={1.3}>
    {children}
  </BaseText>
);

const SM = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={13} fontWeight={400} lineHeight={1.3}>
    {children}
  </BaseText>
);

const SMMedium = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={13} fontWeight={500} lineHeight={1.3}>
    {children}
  </BaseText>
);

const SMBold = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={13} fontWeight={700} lineHeight={1.3}>
    {children}
  </BaseText>
);

const SMBlack = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={13} fontWeight={900} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XS = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={11} fontWeight={400} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XSBold = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={11} fontWeight={700} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XSMedium = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={11} fontWeight={500} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XXS = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={9} fontWeight={400} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XXSMedium = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={9} fontWeight={500} lineHeight={1.3}>
    {children}
  </BaseText>
);

const XXSBold = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={9} fontWeight={700} lineHeight={1.3}>
    {children}
  </BaseText>
);

const ButtonLG = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={17} fontWeight={600} lineHeight={1.17}>
    {children}
  </BaseText>
);

const ButtonMD = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={15} fontWeight={600} lineHeight={1.17}>
    {children}
  </BaseText>
);

const ButtonSM = ({ children, ...props }: TextVariantProps) => (
  <BaseText {...props} fontSize={13} fontWeight={600} lineHeight={1.3}>
    {children}
  </BaseText>
);

const Text = (props: TextVariantProps) => <MD {...props} />;

Text.LG = LG;
Text.MD = MD;
Text.MDMedium = MDMedium;
Text.MDBold = MDBold;
Text.SM = SM;
Text.SMMedium = SMMedium;
Text.SMBold = SMBold;
Text.SMBlack = SMBlack;
Text.XS = XS;
Text.XSMedium = XSMedium;
Text.XSBold = XSBold;
Text.XXS = XXS;
Text.XXSBold = XXSBold;
Text.XXSMedium = XXSMedium;
Text.ButtonLG = ButtonLG;
Text.ButtonMD = ButtonMD;
Text.ButtonSM = ButtonSM;

export type TextSize = keyof typeof Text;
export const textSizeMap: Record<TextSize, React.ComponentType<TextVariantProps>> = {
  XXS,
  XXSBold,
  XXSMedium,
  XSMedium,
  XS,
  XSBold,
  SM,
  SMMedium,
  SMBold,
  SMBlack,
  MD,
  MDMedium,
  MDBold,
  LG,
  ButtonSM,
  ButtonMD,
  ButtonLG,
};

export default Text;
